import router from "@/router";
import { auth } from "@/firebase";
import { signOut } from "firebase/auth";


const state = {
  token: localStorage.getItem("token") || null,
  facebookToken: localStorage.getItem("facebookToken") || null,
  userData: JSON.parse(localStorage.getItem("userData")) || {},
  pageData: JSON.parse(localStorage.getItem("pageData")) || {},
  adData: JSON.parse(localStorage.getItem("adData")) || {},
  pageSetting: JSON.parse(localStorage.getItem("pageSetting")) || {},
  userActive: localStorage.getItem("userActive") || 'anonymous',
  credit: localStorage.getItem("credit") || 0,
  point: localStorage.getItem("point") || 0,
  financialData: JSON.parse(localStorage.getItem("financialData")) || {},
  rewards: JSON.parse(localStorage.getItem("rewards")) || [],
  transaction: JSON.parse(localStorage.getItem("transaction")) || [],
  history: JSON.parse(localStorage.getItem("history")) || [],
  subscription: JSON.parse(localStorage.getItem("subscription")) || null,
  usage: JSON.parse(localStorage.getItem("usage")) || null

};

const getters = {
  getToken: (state) => {
    return state.token;
  },
  getSubscription: (state) => {
    return state.subscription;
  },
  getUsage: (state) => {
    return state.usage;
  },
  getFacebookToken: (state) => {
    return state.facebookToken;
  },
  getUserData: (state) => {
    console.log(state.userData)
    return state.userData;
  },
  getPageData: (state) => {
    return state.pageData;
  },
  getAdData: (state) => {
    return state.adData
  },
  getPageSetting: (state) => {
    return state.pageSetting;
  },
  getCredit: (state) => {
    return parseFloat(state.credit);
  },
  getTransaction: (state) => {
    return state.transaction
  },
  getHistory: (state) => {
    return state.history
  }
};

const actions = {
  setToken({ commit }, token) {
    return new Promise((resolve) => {
      let header_token = `${token}`;
      commit("SET_TOKEN", header_token);
      resolve(header_token);
    });
  },
  setSubscription({ commit }, subscription) {
    return new Promise((resolve) => {
      commit("SET_SUBSCRIPTION", subscription);
      resolve(subscription);
    });
  },
  setUsage({ commit }, usage) {
    return new Promise((resolve) => {
      commit("SET_USAGE", usage);
      resolve(usage);
    });
  },

  setFacebookToken({ commit }, token) {
    return new Promise((resolve) => {
      commit("SET_FACEBOOK_TOKEN", token);
      resolve(token);
    });
  },

  setCredit({ commit }, credit) {
    return new Promise((resolve) => {
      commit("UPDATE_CREDIT", credit);
      resolve(credit);
    });
  },
  setUserData({ commit }, userData) {
    return new Promise((resolve) => {
      commit("UPDATE_USER_DATA", userData);
      resolve(userData);
    });
  },
  setPageData({ commit }, pageData) {
    return new Promise((resolve) => {
      commit("UPDATE_PAGE_DATA", pageData);
      resolve(pageData);
    });
  },
  setAdData({ commit }, adData) {
    return new Promise((resolve) => {
      commit("UPDATE_AD_DATA", adData);
      resolve(adData);
    });
  },
  removePageData({ commit }) {
    commit("DEL_PAGE_DATA");

  },
  setPageSetting({ commit }, pageSetting) {
    return new Promise((resolve) => {
      commit("UPDATE_PAGE_SETTING", pageSetting);
      resolve(pageSetting);
    });
  },
  setFinancialData({ commit }, financialData) {
    return new Promise((resolve) => {
      commit("UPDATE_FINANCIAL_DATA", financialData);
      resolve(financialData);
    });
  },
  setTransaction({ commit }, transaction) {
    return new Promise((resolve) => {
      commit("UPDATE_TRANSACTION", transaction);
      resolve(transaction);
    });
  },
  setHistory({ commit }, history) {
    return new Promise((resolve) => {
      commit("UPDATE_HISTORY", history);
      resolve(history);
    });
  },
  setUserActive({ commit }, userActive) {
    return new Promise((resolve) => {
      commit("UPDATE_USER_ACTIVE", userActive);
      resolve(userActive);
    });
  },

  setDisplayName({ commit }, name) {
    return new Promise((resolve) => {
      commit("UPDATE_USER_INFO", { displayName: name });
      resolve(name);
    });
  },

  // checkAuth({ commit, getters }) {
  //   return new Promise((resolve, reject) => {
  //     let header_token = getters.getToken;
  //     if (!header_token) {
  //       return reject({ success: false });
  //     }
  //     axios
  //       .get(`${process.env.VUE_APP_BACKEND_API_URL}/auth/info`, {
  //         headers: { Authorization: header_token },
  //       })
  //       .then(({ data }) => {
  //         if (data.success) {
  //           commit("UPDATE_USER_INFO", { displayName: data.username });
  //         } else {
  //           commit("DEL_TOKEN");
  //           reject(data);
  //           return router.push("/logout");
  //         }
  //         return resolve(data);
  //       })
  //       .catch((err) => {
  //         commit("DEL_TOKEN");
  //         reject(err);
  //         return router.push("/logout");
  //       });
  //   });
  // },
  async logout({ commit }) {
    try {
      await signOut(auth); // ✅ ใช้ Firebase Modular SDK

      localStorage.clear();
      commit("DEL_TOKEN");

      if (router.currentRoute.path !== "/login") {
        await router.replace("/");
      }
    } catch (error) {
      commit("DEL_TOKEN");
      if (router.currentRoute.path !== "/login") {
        await router.replace("/");
      }
      throw error;
    }
  },
};

const mutations = {



  UPDATE_USER_DATA(state, userData) {
    localStorage.setItem("userData", JSON.stringify(userData));
    state.userData = userData;
  },
  SET_SUBSCRIPTION(state, subscription) {
    localStorage.setItem("subscription", JSON.stringify(subscription));
    state.subscription = subscription;
  },
  SET_USAGE(state, usage) {
    localStorage.setItem("usage", JSON.stringify(usage));
    state.usage = usage;
  },
  UPDATE_PAGE_DATA(state, pageData) {
    localStorage.setItem("pageData", JSON.stringify(pageData));
    state.pageData = pageData;
  },
  UPDATE_AD_DATA(state, adData) {
    localStorage.setItem("adData", JSON.stringify(adData));
    state.adData = adData;
  },
  DEL_PAGE_DATA(state) {
    localStorage.removeItem("pageData");
    state.pageData = null;
  },
  UPDATE_PAGE_SETTING(state, pageSetting) {
    localStorage.setItem("pageSetting", JSON.stringify(pageSetting));
    state.pageSetting = pageSetting;
  },
  UPDATE_FINANCIAL_DATA(state, financialData) {
    localStorage.setItem("financialData", JSON.stringify(financialData));
    state.financialData = financialData;
  },

  UPDATE_TRANSACTION(state, transaction) {
    localStorage.setItem("transaction", JSON.stringify(transaction));
    state.transaction = transaction;
  },
  UPDATE_HISTORY(state, history) {
    localStorage.setItem("history", JSON.stringify(history));
    state.history = history;
  },

  UPDATE_CREDIT(state, credit) {
    localStorage.setItem("credit", credit);
    state.credit = credit;
  },
  SET_TOKEN(state, token) {
    localStorage.setItem("token", token);
    state.token = token;
  },
SET_FACEBOOK_TOKEN(state, token) {
  localStorage.setItem("facebookToken", token);
  state.facebookToken = token;   // ✅ ถูกต้อง
},
  DEL_TOKEN(state) {
    localStorage.removeItem("token");
    state.token = null;
  },

};

export default {
  state,
  getters,
  actions,
  mutations,
};
